export default __webpack_public_path__ + "static/media/placeholder_business02-it-mobile.d4411989.png";